import React, { useMemo } from 'react';
import { Form, Formik } from 'formik';

import { __t } from '@mssgme/shared';
import { useCRMData, useSavedOrders } from '../../../hooks';
import { TextField } from '../../../UI';
import { useOrderSubmit } from '../../useOrderSubmit';
import { StepsFooter } from './StepsFooter';

const INITIAL_SHIPPING_ADDRESS = {
    city: '',
    state: '',
    address: '',
    postalCode: '',
};

function ShippingAddressStep() {
    const { form } = useCRMData();
    const { currentOrder } = useSavedOrders();
    const initialValues = useMemo(
        () => ({ shippingAddress: currentOrder?.shippingAddress || INITIAL_SHIPPING_ADDRESS }),
        [currentOrder?.shippingAddress]
    );
    const doSubmit = useOrderSubmit(currentOrder?._id);

    if (!currentOrder) {
        return null;
    }

    const requestCity = !form.optional?.city;
    const requestState = !form.optional?.state;
    const requestPostalCode = !form.optional?.postalCode;

    return (
        <Formik initialValues={initialValues} onSubmit={doSubmit}>
            {({ isSubmitting, handleSubmit }) => (
                <Form>
                    {requestCity && (
                        <TextField
                            required
                            name="shippingAddress.city"
                            placeholder={__t('shippingAddress.placeholder.city')}
                        />
                    )}
                    {requestState && (
                        <TextField
                            required
                            name="shippingAddress.state"
                            placeholder={__t('shippingAddress.placeholder.state')}
                        />
                    )}
                    <TextField
                        required
                        name="shippingAddress.address"
                        placeholder={__t('shippingAddress.placeholder.address')}
                    />
                    {requestPostalCode && (
                        <TextField
                            required
                            name="shippingAddress.postalCode"
                            placeholder={__t('shippingAddress.placeholder.postalCode')}
                        />
                    )}

                    <StepsFooter prev next={handleSubmit} disabled={isSubmitting} />
                </Form>
            )}
        </Formik>
    );
}

export default ShippingAddressStep;
